import { useContext } from 'react';
import { AskPlatoLauncherContext, type AskPlatoLauncher } from '../context/ask-plato-launcher.ts';

export function useAskPlatoLauncher(): AskPlatoLauncher {
    const launcher = useContext(AskPlatoLauncherContext);

    if (!launcher) {
        throw new Error('useAskPlatoLauncher must be used within an AskPlatoLauncherContext provider');
    }

    return launcher;
}
